import React from "react";
import MainImage from "../../assets/HeroImages/MainPot7.jpg";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import PastWork from "../../components/PastWord";
import About from "../../components/About";
import Testimony from "../../components/Testimony";
import { Helmet } from "react-helmet";

function TheBusinessGlowUp() {
  return (
    <div className="relative min-h-screen w-screen overflow-x-hidden bg-[#F7F3F2]">
 <Helmet>
  <title>Business Glow Up Brand Makeover for Women Entrepreneurs | Woaom Web Design</title>
  <meta
    name="description"
    content="Woaom Web Design’s Business Glow Up Package helps women entrepreneurs scale with a full brand makeover — custom website, branding, client portals, and conversion-focused digital strategy. Serving Dallas, Houston, Austin, Atlanta, and beyond."
  />
  <meta
    name="keywords"
    content="Business Glow Up package Dallas TX, Houston TX business website makeover, Austin full brand rebrand for women entrepreneurs, Atlanta women-owned business rebranding, New York City female founder brand makeover, Washington DC business glow up web design, Philadelphia PA brand refresh for women entrepreneurs, Memphis TN business website rebrand, Baton Rouge LA women-led business web design, Shreveport LA full business makeover package, New Orleans custom rebrand services, Macon GA women entrepreneurs website refresh, Augusta GA business rebrand studio, Baltimore business glow up services, premium web design for women entrepreneurs, full rebrand package for female founders, digital transformation studio for women-led brands, client portal setup for women-owned businesses, scaling websites for women entrepreneurs, strategic website redesign for women founders, feminine business website design packages, multi-page site builds for women entrepreneurs, startup-ready websites for women founders, professional business brand makeover for women entrepreneurs, content-first design for women-led businesses, powerful website refresh for women entrepreneurs, business systems and website design for women founders, high-converting business website redesigns, women entrepreneurs brand strategy Dallas TX, elevate your business brand online Houston TX"
  />
</Helmet>

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <Navbar />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 bg-[#CFF098] font-semibold text-center">The Business Glow-Up</h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-6xl uppercase">
                Ready to Attract More of Your Ideal Clients? It's Time to Strategically Grow Your Business Online.
              </h2>
              <p className="mb-8 mt-4 max-w-4xl text-base text-black md:mb-12 md:text-lg font-light">
                For established <strong>women-led businesses</strong> seeking to elevate their online authority, drive targeted traffic, and convert more leads into loyal clients.
              </p>
            </div>

            {/* Benefits Grid Styled Like Services.jsx */}
            <div className="mt-12">
              <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4">
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">A Conversion-Focused Website (Up to 7 Pages)</h3>
                  <p className="text-black text-base font-light">
                    Strategically designed to guide visitors through your funnel with dedicated service pages, compelling case studies, and clear CTAs that drive conversions.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Dominate Local Search</h3>
                  <p className="text-black text-base font-light">
                    Keyword research and on-site optimization for local visibility plus foundational Google Business and citation strategy.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Turn Visitors into Leads</h3>
                  <p className="text-black text-base font-light">
                    Capture leads with integrated forms and connect with your email marketing platform to nurture prospects automatically.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Showcase Your Success Stories</h3>
                  <p className="text-black text-base font-light">
                    Build trust with a stunning portfolio section featuring testimonials and real results.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Data-Driven Growth</h3>
                  <p className="text-black text-base font-light">
                    We’ll install Google Analytics and deliver an insights report to guide future strategy.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-16">
              <a href="/contact" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">
                BOOK A STRATEGY SESSION
              </a>
            </div>
          </div>
        </section>
      
        <PastWork />
        <Testimony/>
          <div className="bg-[#2E2D2B]">
          <About/>
        </div>
        <Footer />
      </section>
    </div>
  );
}

export default TheBusinessGlowUp;
